import { render, staticRenderFns } from "./AccessGloboDialog.vue?vue&type=template&id=702d0784&scoped=true"
import script from "./AccessGloboDialog.vue?vue&type=script&lang=ts"
export * from "./AccessGloboDialog.vue?vue&type=script&lang=ts"
import style0 from "./AccessGloboDialog.vue?vue&type=style&index=0&id=702d0784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702d0784",
  null
  
)

export default component.exports